import type { ServerFieldError } from "@/organisms/Ticketing/hooks/useTemplateTest.types"
import type { OnDemandField } from "./JiraTemplateModal.types"

export function filterOnDemandFieldsWithValues(
  onDemandFields?: Record<string, OnDemandField>
): Record<string, OnDemandField> {
  if (!onDemandFields) {
    return {}
  }
  return Object.keys(onDemandFields).reduce(
    (acc, fieldName) => {
      const field = onDemandFields[fieldName]
      if (field.value !== undefined && field.value !== null) {
        acc[fieldName] = field
      }
      return acc
    },
    {} as Record<string, OnDemandField>
  )
}

export function processValidationErrors(
  error: Jira.IssueError,
  t: (key: string) => string
) {
  const { errorCode, fields: errorFields = {}, userMessages = [] } = error
  const formErrors: string[] = []
  const fieldErrors: Record<string, string> = {}
  let hasFieldErrors = false

  if (errorCode === "fieldError" && Object.keys(errorFields).length > 0) {
    formErrors.push(t("error.fieldsError"))
    Object.entries(errorFields).forEach(([fieldKey, errorMessage]) => {
      fieldErrors[fieldKey] = errorMessage
    })
    hasFieldErrors = true
  } else if (errorCode === "notFoundError") {
    formErrors.push(t("error.resourceNotFound"))
  } else if (errorCode === "JiraError") {
    formErrors.push(t("error.creationFailed"))
  }

  if (userMessages.length > 0) {
    formErrors.push(...userMessages)
  }

  return { formErrors, fieldErrors, hasFieldErrors }
}

// A server error holds while its field keeps the value it was reported against
export const toServerErrors = (
  fieldErrors: Record<string, string> = {},
  referenceValues: Record<string, unknown> = {}
): Record<string, ServerFieldError> =>
  Object.fromEntries(
    Object.entries(fieldErrors).map(([name, message]) => [
      name,
      { message, value: referenceValues[name] }
    ])
  )
